import { compact } from 'lodash-es';
import { ActiveServicesReportEntryApiAutomaticServiceState, ActiveServicesReportEntryApiOccurrence, ActiveServicesReportEntryApiPricing, ActiveServicesReportEntryApiStatus, ActiveServicesReportEntryApiTrigger, ActiveServicesReportSortColumnId } from 'anchor-scout-common/types';
import { SearchFilterType } from '../../../components/TableFilters/types';
import { ActiveServicesReportOptionalColumns, FilterType } from './types';
export const activeServicesReportTextsPath = 'activeServicesReport';
export const makeCsv = (headerRow, visibleColumns, entries)=>[
        headerRow
    ].concat(entries.map((entry)=>{
        const row = [
            entry.customerName,
            entry.agreementName,
            entry.serviceName
        ];
        if (visibleColumns[ActiveServicesReportOptionalColumns.Trigger]) {
            row.push(entry.trigger);
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.Pricing]) {
            row.push(entry.pricing);
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.Occurrence]) {
            row.push(entry.occurrence);
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.Rate]) {
            row.push(entry.rawRate.toString());
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.LastBilled]) {
            row.push(entry.formattedLastBilled || '');
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.Assignee]) {
            row.push(entry.assignee);
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState]) {
            row.push(entry.automaticServiceState || '');
        }
        if (visibleColumns[ActiveServicesReportOptionalColumns.Status]) {
            row.push(entry.status);
        }
        return row;
    }));
export const activeServicesReportHeaderColumnDefsForExport = (param)=>{
    let { visibleColumns, texts } = param;
    return compact([
        {
            value: texts.companyName()
        },
        {
            value: texts.agreementName()
        },
        {
            value: texts.serviceName()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
            value: texts.trigger()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
            value: texts.pricing()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
            value: texts.occurrence()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
            value: texts.rate()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
            value: texts.lastBilled()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
            value: texts.assignee()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
            value: texts.automaticServiceState()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
            value: texts.status()
        }
    ]);
};
export const activeServicesReportHeaderColumnDefs = (param)=>{
    let { visibleColumns, texts } = param;
    return compact([
        {
            sortId: ActiveServicesReportSortColumnId.CompanyName,
            value: texts.companyName()
        },
        {
            sortId: ActiveServicesReportSortColumnId.ServiceName,
            value: texts.serviceName()
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
            sortId: ActiveServicesReportSortColumnId.Trigger,
            value: texts.trigger(),
            optionalColumn: ActiveServicesReportOptionalColumns.Trigger
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
            sortId: ActiveServicesReportSortColumnId.Pricing,
            value: texts.pricing(),
            optionalColumn: ActiveServicesReportOptionalColumns.Pricing
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
            sortId: ActiveServicesReportSortColumnId.Occurrence,
            value: texts.occurrence(),
            optionalColumn: ActiveServicesReportOptionalColumns.Occurrence
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
            sortId: ActiveServicesReportSortColumnId.Rate,
            value: texts.rate(),
            optionalColumn: ActiveServicesReportOptionalColumns.Rate
        },
        visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
            sortId: ActiveServicesReportSortColumnId.LastBilled,
            value: texts.lastBilled(),
            optionalColumn: ActiveServicesReportOptionalColumns.LastBilled
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
            sortId: ActiveServicesReportSortColumnId.Assignee,
            value: texts.assignee(),
            optionalColumn: ActiveServicesReportOptionalColumns.Assignee
        },
        visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
            sortId: ActiveServicesReportSortColumnId.AutomaticServiceState,
            value: texts.automaticServiceState(),
            optionalColumn: ActiveServicesReportOptionalColumns.AutomaticServiceState
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
            sortId: ActiveServicesReportSortColumnId.Status,
            value: texts.status(),
            optionalColumn: ActiveServicesReportOptionalColumns.Status
        }
    ]);
};
export const activeServicesReportColumnDefs = (visibleColumns)=>compact([
        {
            width: 234,
            sortable: true
        },
        {
            width: 234,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
            width: 108,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
            width: 108,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
            width: 108,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
            width: 148,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
            width: 148,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
            width: 180,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
            width: 180,
            sortable: true
        },
        visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
            width: 108,
            sortable: true
        }
    ]);
export function getFilterLabels(texts) {
    return {
        [FilterType.CustomerName]: texts.companyName(),
        [FilterType.AgreementName]: texts.agreementName(),
        [FilterType.ServiceName]: texts.serviceName(),
        [FilterType.Occurrence]: texts.occurrence(),
        [FilterType.Trigger]: texts.trigger(),
        [FilterType.Pricing]: texts.pricing(),
        [FilterType.LastBilled]: texts.lastBilled(),
        [FilterType.Assignee]: texts.assignee(),
        [FilterType.AutomaticServiceState]: texts.automaticServiceState(),
        [FilterType.Status]: texts.status()
    };
}
function getBaseOccurrenceFilterOptions(texts) {
    return [
        {
            label: texts.oneTime(),
            value: ActiveServicesReportEntryApiOccurrence.OneTime
        },
        {
            label: texts.weekly(),
            value: ActiveServicesReportEntryApiOccurrence.Weekly
        },
        {
            label: texts.biWeekly(),
            value: ActiveServicesReportEntryApiOccurrence.BiWeekly
        },
        {
            label: texts.monthly(),
            value: ActiveServicesReportEntryApiOccurrence.Monthly
        },
        {
            label: texts.quarterly(),
            value: ActiveServicesReportEntryApiOccurrence.Quarterly
        },
        {
            label: texts.yearly(),
            value: ActiveServicesReportEntryApiOccurrence.Yearly
        },
        {
            label: texts.inStages(),
            value: ActiveServicesReportEntryApiOccurrence.InStages
        }
    ];
}
function getOccurrenceFilterOptions(param) {
    let { onDemandEnabled, texts } = param;
    const base = getBaseOccurrenceFilterOptions(texts);
    if (!onDemandEnabled) return base;
    return [
        ...base,
        {
            label: texts.onDemand(),
            value: ActiveServicesReportEntryApiOccurrence.OnDemand
        }
    ];
}
function getTriggerFilterOptions(texts) {
    return [
        {
            label: texts.manual(),
            value: ActiveServicesReportEntryApiTrigger.Manual
        },
        {
            label: texts.automatic(),
            value: ActiveServicesReportEntryApiTrigger.Automatic
        }
    ];
}
function getPricingFilterOptions(texts) {
    return [
        {
            label: texts.fixed(),
            value: ActiveServicesReportEntryApiPricing.Fixed
        },
        {
            label: texts.perHour(),
            value: ActiveServicesReportEntryApiPricing.PerHour
        },
        {
            label: texts.perUnit(),
            value: ActiveServicesReportEntryApiPricing.PerUnit
        },
        {
            label: texts.range(),
            value: ActiveServicesReportEntryApiPricing.Range
        }
    ];
}
function getAutomaticServiceStateFilterOptions(texts) {
    return [
        {
            label: texts.paused(),
            value: ActiveServicesReportEntryApiAutomaticServiceState.Paused
        },
        {
            label: texts.active(),
            value: ActiveServicesReportEntryApiAutomaticServiceState.Active
        }
    ];
}
function getStatusFilterOptions(texts) {
    return [
        {
            label: texts.approved(),
            value: ActiveServicesReportEntryApiStatus.Approved
        },
        {
            label: texts.amended(),
            value: ActiveServicesReportEntryApiStatus.Amended
        }
    ];
}
export const makeFiltersConfig = (param)=>{
    let { filtersOptions, onDemandEnabled, texts } = param;
    return {
        [FilterType.CustomerName]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.CustomerName] || [],
            removable: true,
            withSearchbox: true
        },
        [FilterType.ServiceName]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.ServiceName] || [],
            removable: true,
            withSearchbox: true
        },
        [FilterType.AgreementName]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.AgreementName] || [],
            removable: true,
            withSearchbox: true
        },
        [FilterType.Assignee]: {
            type: SearchFilterType.MultiSelectFilter,
            options: filtersOptions[FilterType.Assignee] || [],
            removable: true,
            withSearchbox: true
        },
        [FilterType.Occurrence]: {
            type: SearchFilterType.MultiSelectFilter,
            options: getOccurrenceFilterOptions({
                onDemandEnabled,
                texts: texts.occurrenceOptions
            }),
            removable: true,
            withSearchbox: false
        },
        [FilterType.Trigger]: {
            type: SearchFilterType.MultiSelectFilter,
            options: getTriggerFilterOptions(texts.triggerOptions),
            removable: true,
            withSearchbox: false
        },
        [FilterType.Pricing]: {
            type: SearchFilterType.MultiSelectFilter,
            options: getPricingFilterOptions(texts.pricingOptions),
            removable: true,
            withSearchbox: false
        },
        [FilterType.AutomaticServiceState]: {
            type: SearchFilterType.MultiSelectFilter,
            options: getAutomaticServiceStateFilterOptions(texts.automaticServiceStateOptions),
            removable: true,
            withSearchbox: false
        },
        [FilterType.Status]: {
            type: SearchFilterType.MultiSelectFilter,
            options: getStatusFilterOptions(texts.statusOptions),
            removable: true,
            withSearchbox: false
        },
        [FilterType.LastBilled]: {
            type: SearchFilterType.DateRangeFilter,
            removable: true
        }
    };
};
export const getDefaultSort = (sortIds)=>({
        colIndex: sortIds.indexOf(ActiveServicesReportSortColumnId.CompanyName),
        sort: 'desc'
    });
